@ -0,0 +1,39 @@
<template>
  <svg :style="style" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="&#232;&#175;&#132;&#228;&#187;&#183;&#230;&#152;&#159;&#230;&#152;&#159;">
      <rect y="0.5" width="12" height="12" rx="2" :fill="fill" />
      <path id="Star" fill-rule="evenodd" clip-rule="evenodd"
        d="M5.99998 9.45245L3.77957 10.478C3.65501 10.5355 3.50953 10.4763 3.45464 10.3458C3.43745 10.3049 3.43067 10.26 3.43497 10.2156L3.67939 7.6853L2.06268 5.78883C1.97199 5.68245 1.98075 5.51914 2.08225 5.42408C2.11404 5.39431 2.15264 5.37369 2.19431 5.36424L4.56578 4.82599L5.787 2.62835C5.85551 2.50507 6.0064 2.46334 6.12402 2.53515C6.16085 2.55763 6.19149 2.58975 6.21295 2.62835L7.43417 4.82599L9.80565 5.36424C9.93868 5.39443 10.0232 5.53195 9.99437 5.67139C9.98534 5.71505 9.96567 5.75552 9.93727 5.78883L8.32056 7.6853L8.56498 10.2156C8.57869 10.3575 8.48002 10.4842 8.3446 10.4986C8.30219 10.5031 8.25939 10.496 8.22038 10.478L5.99998 9.45245Z"
        fill="white" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconStar',
  props: {
    fontSize: {
      type: String,
      default: '16px'
    },
    fill: {
      type: String,
      default: '#FCA04B'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        cursor: 'pointer',
        'font-size': this.fontSize
      }
    }
  }
}
</script>